export function TermsContentDe() {
  return (
    <div className="space-y-6 text-sm">
      <h2 className="text-lg font-semibold mb-3">Teil C Lizenzbedingungen</h2>

      <section>
        <h3 className="font-semibold mb-2">§ C-1 Geltungsbereich der Lizenzbedingungen</h3>
        <p className="mb-3">
          (1) Diese Lizenzbedingungen regeln die Einräumung und den Umfang der Nutzungsrechte an der
          von BLIKS IO bereitgestellten Software. Sie gelten für jede Nutzung der Software durch den
          Kunden, unabhängig davon,
        </p>
        <p className="mb-1 ml-4">
          a) ob die Nutzung im Rahmen eines entgeltlichen Vertragsverhältnisses erfolgt,
        </p>
        <p className="mb-1 ml-4">
          b) ob es sich um eine Test-, Pilot-, Beta- oder sonstige vorvertragliche Nutzung handelt,
          oder
        </p>
        <p className="mb-3 ml-4">
          c) ob die Nutzung im Zusammenhang mit einer technisch erforderlichen Übergangs- oder
          Abwicklungsphase nach Beendigung eines Vertrags erfolgt.
        </p>
        <p className="mb-3">
          (2) Jede Nutzung der Software ist ausschließlich auf Grundlage dieser Lizenzbedingungen
          zulässig.
        </p>
        <p className="mb-3">
          (3) Soweit zwischen den Parteien ein gesondertes Vertragsverhältnis besteht, bestimmen
          sich Laufzeit, Vergütung, Leistungsumfang und Haftung nach den dort getroffenen
          Regelungen.
        </p>
        <p className="mb-3">
          (4) Sofern ausdrücklich vereinbart, kann die Lizenzierung im Rahmen eines Reseller-,
          White-Label- oder Plattformmodells erfolgen. In diesem Fall gelten gesonderte
          Lizenzmetriken (insbesondere Seat- oder Mandantenmodelle) gemäß individueller
          Vereinbarung. Ohne ausdrückliche Vereinbarung findet eine solche B2B2B-Lizenzierung nicht
          statt.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-2 Einräumung der Nutzungsrechte (Grundlizenz)</h3>
        <p className="mb-3">
          (1) BLIKS IO räumt dem Kunden für die Dauer der jeweils zulässigen Nutzung ein einfaches,
          nicht ausschließliches, nicht übertragbares und nicht unterlizenzierbares Recht ein, die
          Software im vertraglich vorgesehenen Umfang zu nutzen.
        </p>
        <p className="mb-3">
          (2) Die Nutzung ist ausschließlich für eigene geschäftliche Zwecke des Kunden und nur im
          Rahmen der jeweils vereinbarten Nutzungsparameter (insbesondere Nutzeranzahl,
          Funktionsumfang oder sonstige Lizenzmetriken) zulässig.
        </p>
        <p className="mb-3">
          (3) Eine Überlassung der Software an Dritte, deren Zugänglichmachung gegenüber Dritten
          oder eine Nutzung für Dritte ist nur zulässig, soweit dies ausdrücklich vereinbart wurde.
        </p>
        <p className="mb-3">
          (4) Mit Ausnahme der in diesen Lizenzbedingungen ausdrücklich eingeräumten Rechte werden
          dem Kunden keine weiteren Nutzungs- oder Verwertungsrechte eingeräumt. Sämtliche Rechte an
          der Software, einschließlich aller urheberrechtlichen Nutzungsrechte, gewerblichen
          Schutzrechte und sonstigen geistigen Eigentumsrechte, verbleiben bei BLIKS IO.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-2a Lizenzmetriken und Clusterstruktur (B2B)</h3>
        <p className="mb-3">
          (1) Im Standard-B2B-Modell erfolgt die Lizenzierung nutzerbasiert nach der
          Organisationsgröße des Kunden („Cluster-Modell"). Maßgeblich ist die im Bestellformular
          vereinbarte Größenklasse. Diese bestimmt die maximal zulässige Anzahl von berechtigten
          Nutzern innerhalb der lizenznehmenden Organisation. Eine personenbezogene Zuweisung
          einzelner Nutzerlizenzen („Seats") erfolgt im Standard-B2B-Modell nicht.
        </p>
        <p className="mb-3">
          (2) Eine Seat- oder Mandantenlizenzierung kommt ausschließlich zur Anwendung, wenn die
          Parteien ausdrücklich ein Reseller-, White-Label- oder sonstiges B2B2B-Modell vereinbaren.
          Ohne eine solche ausdrückliche Vereinbarung ist eine Nutzung für Dritte unzulässig.
        </p>
        <p className="mb-3">
          (3) Der Kunde ist nicht berechtigt, die Software oder einzelne Funktionalitäten als
          eigenständige, substitutive oder wirtschaftlich vergleichbare Lösung gegenüber Dritten
          bereitzustellen, weiterzuvermarkten oder im Rahmen eines eigenen Plattform- oder
          Leistungsangebots zu integrieren, sofern nicht ausdrücklich eine entsprechende
          Vereinbarung getroffen wurde.
        </p>
        <p className="mb-3">
          (4) Die technische Mandantenfähigkeit der Software begründet kein eigenständiges
          Nutzungsrecht weiterer Organisationen oder rechtlich selbstständiger Einheiten.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-3 Nutzungsumfang und Beschränkungen</h3>
        <p className="mb-3">(1) Dem Kunden ist es untersagt,</p>
        <p className="mb-1 ml-4">
          a) die Software unbefugten Dritten zugänglich zu machen oder sie für Dritte zu betreiben,
        </p>
        <p className="mb-1 ml-4">
          b) technische Schutzmaßnahmen zu umgehen oder Sicherheitsmechanismen zu manipulieren,
        </p>
        <p className="mb-3 ml-4">
          c) die Software zu vervielfältigen, zu verbreiten, öffentlich zugänglich zu machen oder in
          sonstiger Weise zu verwerten, soweit dies nicht zur vertragsgemäßen Nutzung erforderlich
          ist.
        </p>
        <p className="mb-3">
          (2) Eine Bearbeitung, Dekompilierung oder sonstige Form des Reverse Engineerings ist nur
          insoweit zulässig, als dies nach zwingenden gesetzlichen Vorschriften ausdrücklich erlaubt
          ist.
        </p>
        <p className="mb-3">
          (3) Der Kunde hat angemessene organisatorische Maßnahmen zu treffen, um eine
          vertragswidrige Nutzung der Software zu verhindern.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-4 Test-, Beta- und Vorvertragsnutzung</h3>
        <p className="mb-3">
          (1) Sofern dem Kunden die Software vor Abschluss eines entgeltlichen Vertragsverhältnisses
          zu Test-, Pilot-, Beta- oder sonstigen Evaluierungszwecken zur Verfügung gestellt wird
          („Testnutzung"), erfolgt die Nutzung ausschließlich auf Grundlage dieser
          Lizenzbedingungen.
        </p>
        <p className="mb-3">
          (2) Die Testnutzung ist auf die Evaluierung der Software beschränkt und darf nicht für
          produktive Geschäftszwecke eingesetzt werden, sofern nicht ausdrücklich etwas anderes
          vereinbart wurde.
        </p>
        <p className="mb-3">
          (3) Die Einräumung von Nutzungsrechten im Rahmen der Testnutzung erfolgt unentgeltlich und
          jederzeit widerruflich, sofern nicht ausdrücklich eine feste Testdauer vereinbart wurde.
        </p>
        <p className="mb-3">
          (4) Ein Anspruch auf dauerhafte Bereitstellung der Software oder auf Abschluss eines
          entgeltlichen Vertrags besteht nicht.
        </p>
        <p className="mb-3">
          (5) Soweit ein Vertragsverhältnis besteht, gelten die Regelungen des jeweils einschlägigen
          Vertragswerks, insbesondere Teil A und Teil B, soweit anwendbar.
        </p>
        <p className="mb-3">
          (6) Test- oder Pilotnutzungen können auf bestimmte Funktionsbereiche, Module oder
          Organisationsgrößen beschränkt werden. Ein Anspruch auf Übertragung der Testkonfiguration
          in eine produktive Lizenzstruktur besteht nicht.
        </p>
        <p className="mb-3">
          (7) Beta-Module werden gesondert gekennzeichnet und gelten nicht als vertraglich
          geschuldete Kernfunktionalitäten. Sie können jederzeit angepasst oder eingestellt werden,
          ohne dass hierdurch Ansprüche auf Erweiterung des Leistungsumfangs entstehen.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-5 Vertragsgebundene Nutzung</h3>
        <p className="mb-3">
          (1) Mit Beendigung der jeweils zulässigen Nutzungsphase erlöschen sämtliche dem Kunden
          eingeräumten Nutzungsrechte an der Software automatisch, ohne dass es einer gesonderten
          Erklärung bedarf.
        </p>
        <p className="mb-3">
          (2) Ab dem Zeitpunkt der Beendigung ist eine produktive Nutzung der Software unzulässig.
        </p>
        <p className="mb-3">
          (3) Soweit dem Kunden nach Vertragsbeendigung eine technisch erforderliche Übergangs- oder
          Exportphase eingeräumt wird, beschränkt sich das Nutzungsrecht ausschließlich auf den
          Zugriff zum Zwecke des Datenexports oder der Datenmigration gemäß § B1-3. Eine
          darüberhinausgehende Nutzung ist ausgeschlossen.
        </p>
        <p className="mb-3">
          (4) Ein Anspruch auf Fortsetzung der Nutzung, auf erneute Einräumung von Nutzungsrechten
          oder auf Überlassung der Software in körperlicher oder installierbarer Form besteht nicht.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-6 Rechteinhaberschaft und Schutzrechte</h3>
        <p className="mb-3">
          (1) Die Software sowie sämtliche damit verbundenen urheberrechtlichen Nutzungsrechte,
          gewerblichen Schutzrechte, Geschäftsgeheimnisse und sonstigen geistigen Eigentumsrechte
          stehen ausschließlich BLIKS IO oder den jeweiligen Rechteinhabern zu.
        </p>
        <p className="mb-3">
          (2) Vom Kunden übermittelte Anregungen, Verbesserungsvorschläge oder Feedback zur Software
          dürfen von BLIKS IO unentgeltlich und zeitlich unbeschränkt für Zwecke der
          Weiterentwicklung und Optimierung der Software verwendet werden, sofern hierdurch keine
          vertraulichen Informationen des Kunden offenbart oder verwertet werden.
        </p>
        <p className="mb-3">
          (3) Der Kunde ist nicht berechtigt, Kennzeichen, Marken oder sonstige Schutzrechte von
          BLIKS IO ohne ausdrückliche Zustimmung außerhalb der vertragsgemäßen Nutzung zu verwenden.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-7 Open-Source- und Drittkomponenten</h3>
        <p className="mb-3">
          (1) Die Software kann Komponenten enthalten, die unter Open-Source-Lizenzen oder sonstigen
          Drittanbieter-Lizenzbedingungen stehen.
        </p>
        <p className="mb-3">
          (2) Soweit für einzelne Komponenten abweichende Lizenzbedingungen gelten, gehen diese
          hinsichtlich der jeweiligen Komponente vor. Weitergehende Rechte werden hierdurch nicht
          eingeräumt.
        </p>
        <p className="mb-3">
          (3) Die Nutzung solcher Komponenten erfolgt im Rahmen der jeweils einschlägigen
          Lizenzbedingungen. Eine Verpflichtung zur Offenlegung des Quellcodes der Gesamtsoftware
          entsteht hierdurch nicht. Eine Verpflichtung zur Offenlegung des Quellcodes besteht nur,
          soweit zwingende Open-Source-Lizenzbedingungen dies erfordern.
        </p>
      </section>
    </div>
  );
}
